export enum OperationScheduler {
  SERVICE = "SERVICE",
  DEVICE = "DEVICE",
}
